import { Component, ErrorInfo } from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';

import { PrivateRoute } from './components/app';
import { i18n, store } from './config';
import { AnalyticsProvider, LocationProvider, ModalsProvider } from './contexts';
import { EnvVariable } from './enums';
import './index.css';
import {
  OrganizationDetailsPage,
  OrganizationDevicesPage,
  OrganizationPage,
  OrganizationUsersPage,
  PatientPage,
  PatientsPage,
  ProfilePage,
} from './pages/app';
import { ForgotPasswordPage, LoginPage, SignUpPage } from './pages/auth';
import { getStringEnvVariable } from './utils';

export class App extends Component {
  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('Healthcare error:', error, errorInfo);
  }

  render() {
    const segmentWriteKey = getStringEnvVariable(EnvVariable.SEGMENT_WRITE_KEY);

    return (
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <AnalyticsProvider writeKey={segmentWriteKey}>
            <BrowserRouter>
              <ModalsProvider>
                <LocationProvider>
                  <Routes>
                    <Route path="/" element={<Navigate to="/app/patients" />} />

                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    <Route path="/signup" element={<SignUpPage />} />
                    <Route
                      path="/app"
                      element={
                        <PrivateRoute>
                          <Outlet />
                        </PrivateRoute>
                      }
                    >
                      <Route path="organization" element={<OrganizationPage />} />
                      <Route path="organization/details" element={<OrganizationDetailsPage />} />
                      <Route path="organization/devices" element={<OrganizationDevicesPage />} />
                      <Route path="organization/users" element={<OrganizationUsersPage />} />
                      <Route path="patients" element={<PatientsPage />} />
                      <Route path="patients/:patientId" element={<PatientPage />} />
                      <Route path="profile" element={<ProfilePage />} />
                    </Route>
                  </Routes>
                </LocationProvider>
              </ModalsProvider>
            </BrowserRouter>
          </AnalyticsProvider>
        </I18nextProvider>
      </Provider>
    );
  }
}
